import {Injectable, signal, WritableSignal} from '@angular/core';
import {FileHash, FileQueueItem} from "../interfaces/file-utils-interface";
import {HttpClient, HttpEventType, HttpHeaders} from "@angular/common/http";
import {map, Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {TramiteService} from "../../users/tramites/services/tramite.service";
import {CatalogoInterface} from "../../users/interfaces/proyecto.interface";

const apiVucUrl = environment.apiVucUrl

@Injectable({providedIn: 'root'})
export class FileUtilsService {
    file!: File;
    hash: string | undefined | null = null;
    fileBuffer!: string | ArrayBuffer | null;
    fileBuffer2: string | ArrayBuffer | null = null
    fileQueue: WritableSignal<FileQueueItem[]> = signal([]);
    showLoader: WritableSignal<boolean> = signal(false);
    archivoTipo: WritableSignal<CatalogoInterface[]> = signal([])
    idProyecto: WritableSignal<string | null> = signal(null)
    maxFileSize = 20000000;
    formatoArchivo = '.pdf, .jpeg, .jpg, .png, .gif, .bmp, .webp, .heic';


    constructor(private http: HttpClient, protected tramite: TramiteService) {
    }

    /**
     * Calcula el hash del archivo proporcionado.
     * Estado = 0 --> Invalido,
     * Estado = 1 -->Ok,
     * Estado = 3 --> Error
     */
    async calcularHash(inputFile: File[]): Promise<number> {
        let estado = 0;
        if (!inputFile) {
            console.error("No se puede calcular hash, inputFile invalido o no existe");
        }
        this.file = inputFile[0];
        try {
            //Generar hash
            const outputFile = inputFile[0];
            const buffer = await outputFile.arrayBuffer();
            const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
            const hashArray = Array.from(new Uint8Array(hashBuffer));
            this.hash = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
            if (this.hash) {
                estado = 1
            }
            console.log(`inputFile[0] -> hash:${this.hash}`);
        } catch (error) {
            console.log(error);
            estado = 3;
        }
        return estado;
    }

    /**
     * Calcula el hash del archivo proporcionado.
     * Estado = 0 --> Invalido,
     * Estado = 1 -->Ok,
     * Estado = 3 --> Error
     */
    async calcularSingleFileHash(inputFile: File): Promise<number> {
        let estado = 0;
        if (!inputFile) {
            console.error("No se puede calcular hash, inputFile invalido o no existe");
        }
        this.file = inputFile;
        try {
            //Generar hash
            const buffer = await this.file.arrayBuffer();
            const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
            const hashArray = Array.from(new Uint8Array(hashBuffer));
            this.hash = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
            if (this.hash) {
                estado = 1
            }
            console.log(`inputFile[0] -> hash:${this.hash}`);
        } catch (error) {
            console.log(error);
            estado = 3;
        }
        return estado;
    }

    async fileUploadToBuffer(event: any, fileUpload: any): Promise<number> {
        this.file = event.files[0];
        let estado = await this.calcularHash(event.files);
        const reader = new FileReader();
        reader.readAsDataURL(this.file);
        reader.onload = () => {
            this.fileBuffer2 = reader.result;
        };
        if (estado === 3) {
            console.log('Ocurrió un error al leer archivo. Estado=3');
            fileUpload.clear();
        } else if (estado === 0) {
            console.log('Ocurrió un error al leer archivo. Estado=0');
            fileUpload.clear();
        } else if (estado === 1) {
            console.log('Archivo procesado en buffer correctamente. Estado=1');
        }
        return estado;
    }

    async singleFileUploadToBuffer(file: File, fileUpload: any): Promise<number> {
        this.file = file;
        let estado = await this.calcularSingleFileHash(file);
        const reader = new FileReader();
        reader.readAsDataURL(this.file);
        reader.onload = () => {
            this.fileBuffer2 = reader.result;
        };
        if (estado === 3) {
            console.log('Ocurrió un error al leer archivo. Estado=3');
            fileUpload.clear();
        } else if (estado === 0) {
            console.log('Ocurrió un error al leer archivo. Estado=0');
            fileUpload.clear();
        } else if (estado === 1) {
            console.log('Archivo procesado en buffer correctamente. Estado=1');
        }
        return estado;
    }

    addItemToQueue(fileItem: FileQueueItem) {
        if (!fileItem) {
            console.error(`[${fileItem}] no pudo agregar al a cola de archivos a procesar.`);
            return;
        }
        const isDuplicate = this.fileQueue().some(item => item.hash === fileItem.hash);
        if (!isDuplicate) {
            this.fileQueue().push(fileItem);
            console.info(`[${fileItem.hash}] agregado a la cola de archivos a procesar.`)
        } else {
            console.error(`[${fileItem.hash}] duplicado, no se agrego a la cola de archivos a procesar.`);
        }
    }

    removeItemFromQueue(idRequisito: string): void {
        if (!this.fileQueue()) {
            return;
        }
        const updatedQueue = this.fileQueue().filter(item =>
            Number.parseFloat(<string>item.frm.get("idRequisito")) !== Number.parseInt(idRequisito)
        );
        if (updatedQueue.length) {
            console.log(`fileItem #${idRequisito} removido correctamente`);
        }
        this.fileQueue.set(updatedQueue);
    }

    removeItemFromQueueByHash(hash: string): void {
        if (!this.fileQueue()) {
            return;
        }
        const updatedQueue = this.fileQueue().filter(item =>
            <string>item.frm.get("hash") !== hash
        );
        if (updatedQueue.length) {
            console.log(`fileItem #${hash} removido correctamente`);
        }
        this.fileQueue.set(updatedQueue);
    }

    isIdRqInQueue(idRequisito: string): boolean {
        //console.log(`idRequisito en cola: ${idRequisito}`);

        if (!this.fileQueue()) {
            return false;
        }
        return this.fileQueue().some(item => Number.parseFloat(<string>item.frm.get("idRequisito")) === Number.parseInt(idRequisito));
    }

    isHashInQueue(hash: string): boolean {
        if (!this.fileQueue()) {
            return false;
        }
        return this.fileQueue()
            .some(item => item.hash === hash);
    }

    /**
     * Verifica si el archivo que se va a cargar ya existe para el proyecto especificado.
     */
    verificar(verificar: FileHash) {
        const headers = new HttpHeaders({
            'Accept': '*/*'
        })
        return this.http.post(apiVucUrl + `api/v1.0/archivos/verificar`, verificar, {
            observe: 'response',
            headers: headers
        },);
    }

    /**
     * Sube el archivo y notifica progreso al metodo que lo invoco
     */
    upload(file: FileQueueItem): Observable<any> {
        const headers = new HttpHeaders({
            'Accept': '*/*'
        });
        let payload = file.frm
        return this.http.post(apiVucUrl + `api/v1.0/archivos`, payload, {
            observe: 'events',
            reportProgress: true,
            headers: headers,
        }).pipe(
            map(event => {
                switch (event.type) {
                    case HttpEventType.UploadProgress:
                        const progress = event.total ? Math.round((100 * event.loaded) / event.total) : 0;
                        return {type: 'progress', progress};
                    case HttpEventType.Response:
                        return {type: 'response', body: event.body};
                    default:
                        return {type: 'unknown', event};
                }
            })
        );
    }
 /**
  * Procesa los archivos seleccionados y notifica progreso al metodo que lo invoco
  * Este metodo se utiliza para aquellos archivos que ya existen para N proyectos y reutilizarlos*/
    uploadPersonas(file: FileQueueItem): Observable<any> {
        const headers = new HttpHeaders({
            'Accept': '*/*'
        });
        let payload = file.frm
        return this.http.post(apiVucUrl + `api/v1.0/personas/archivos`, payload, {
            observe: 'events',
            reportProgress: true,
            headers: headers,
        }).pipe(
            map(event => {
                switch (event.type) {
                    case HttpEventType.UploadProgress:
                        const progress = event.total ? Math.round((100 * event.loaded) / event.total) : 0;
                        return {type: 'progress', progress};
                    case HttpEventType.Response:
                        return {type: 'response', body: event.body};
                    default:
                        return {type: 'unknown', event};
                }
            })
        );
    }

    /**Tipos de formatos validacion**/
    getMimeType(extension: string): string {
        const mimeTypes: { [key: string]: string } = {
            '.pdf': 'application/pdf',
            '.jpeg': 'image/jpeg',
            '.jpg': 'image/jpeg',
            '.png': 'image/png',
            '.gif': 'image/gif',
            '.bmp': 'image/bmp',
            '.webp': 'image/webp',
            '.heic': 'image/heic',
        };
        return mimeTypes[extension] || '';
    }

    getAllowedMimeTypes(): string[] {
        return this.formatoArchivo.split(',').map(ext => this.getMimeType(ext.trim()));
    }
}




